/**
 * Article hero interactions.
 */
export default class ArticleHero {
  /**
   * @param {HTMLElement} element - The article hero element.
   */
  constructor(element) {
    this.element = element;
    this.backLink = this.element.querySelector('[data-article-hero-back]');

    this.init();
  }

  init() {
    if (!this.backLink) return;

    // A referrer alone can also be present when a link opens in a fresh tab.
    if (window.history.length <= 1 || !document.referrer) return;

    try {
      if (new URL(document.referrer).origin !== window.location.origin) return;
    } catch (error) {
      return;
    }

    this.backLink.style.removeProperty('display');

    this.backLink.addEventListener('click', (event) => {
      event.preventDefault();

      window.history.back();
    });
  }
}
